import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const { hostname } = window.location;
let rootElement = 'root';
if(hostname !== 'localhost') {
  rootElement = 'fresh-uploader';
}

ReactDOM.render(<App />, document.getElementById(rootElement));



// WEBPACK FOOTER //
// ./src/index.js